module.exports = __webpack_public_path__ + "uia-request-rights.e2af1c85dbb77610524950d418f53e8c.svg";